/**
 * A helper that returns a promise after waiting for a specified number of frame ticks
 * This is handy for when heavy things are happening in a the next couple of frames
 * and you want to wait for a moment!
 *
 * @param framesToWait - how many frames to wait defaults to 2 for good luck
 */
export function waitAFrame(framesToWait = 2): Promise<void> {
  return new Promise((resolve) => {
    let framesPassed = 0;

    const checkFrame = (): void => {
      framesPassed++;
      if (framesPassed >= framesToWait) {
        resolve();
      } else {
        requestAnimationFrame(checkFrame);
      }
    };

    requestAnimationFrame(checkFrame);
  });
}
